import { PartialSaveData } from "./partial-save-data";

export class PartialSaveResp {
    httpStatusCode: number;
    message: string;
    data: PartialSaveData;
}